// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TemplateGroupListResolver } from '@services/resolvers/template-group-list.resolver';
import { AuthGuard } from '../../services/route-guards/auth.guard';
import { DealRootComponent } from '../deal/deal-root/deal-root.component';
import { AllDealsComponent } from './all-deals/all-deals.component';
import { CreateDealComponent } from './create-deal/create-deal.component';
import { DealerGuard } from './dealer.guard';
import { UserResolver } from '@services/resolvers/user.resolver';

const routes: Routes = [
    {
        path: '',
        component: AllDealsComponent,
        data: {
            title: '',
        },
        resolve: {
            user: UserResolver,
        },
    },
    {
        path: 'create',
        component: CreateDealComponent,
        data: {
            title: 'Create A Deal',
        },
        resolve: {
            templateGroups: TemplateGroupListResolver,
        },
    },
    {
        path: 'deal/:dealId',
        component: DealRootComponent,
        canActivate: [AuthGuard, DealerGuard],
        loadChildren: () => import('../deal/deal-routing.module').then((m) => m.DealRoutingModule),
        data: {
            title: 'Your Deal',
        },
    },
    {
        path: '**',
        redirectTo: '',
        pathMatch: 'full',
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class DealsRoutingModule {}
